import { useCallback } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import api, { getBaseId, getToken } from "@/lib/api";
import { queryClient } from "@/lib/queryClient";

// Cache entre navegações (React Query). A chave inclui base selecionada e sessão.
export function useFetch(path, params) {
  const queryKey = ["fetch", path, params || null, getBaseId(), (getToken() || "").slice(-16)];
  const q = useQuery({
    queryKey,
    queryFn: async () => (await api.get(path, { params })).data,
    placeholderData: keepPreviousData,
  });
  const keyStr = JSON.stringify(queryKey);
  const refetch = useCallback(() => q.refetch({ cancelRefetch: false }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [keyStr]);
  const setData = useCallback((d) => queryClient.setQueryData(queryKey, (old) => (typeof d === "function" ? d(old) : d)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [keyStr]);
  return { data: q.data ?? null, loading: q.isPending, error: q.error || null, refetch, setData };
}
